import {GroupAdmin} from './group_admin'

class GroupNav extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    this.is_admin = (this.dataset.is_admin == 'true');
    this.innerHTML = `
      <style>
        group-nav {
          height: calc(100vh - 52px);
          display: block;
          width: 300px;
          float:left;
          padding-top: 15px;
          display: flex; flex-direction: column;
          position: fixed;
        }

        #group-nav-options {
          flex-grow: 1;
          overflow:auto;
        }

        group-nav .input-group-addon span {
          font-size: 18px;
        }

        group-nav .group-nav-path {
          font-size: 14px;
        }

        group-nav .group-nav-path span {
          cursor: pointer;
        }
      </style>
      <div id="filters-row" class="row">
        <div class="col-sm-12">
          <div class="input-group">
              <span class="input-group-addon"><span class="fa fa-search"></span></span>
              <input type="text" id="group-filter" class="form-control" placeholder="Search" autocomplete="off">
          </div>
          <div id="group-filter-options">
            <label>Search By:</label>
            <select class="form-control">
              <option value=${GroupNav.SEARCH_TYPE.GROUPS_AND_LOCATIONS}>Groups and Locations</option>
              <option value=${GroupNav.SEARCH_TYPE.LOCATION_BY_DID}>Tracking Number</option>
              <option value=${GroupNav.SEARCH_TYPE.GROUPS_BY_EMAIL}>User Email</option>
            </select>
            <div class="checkbox">
              <label>
                <input id="show_inactive" type="checkbox" value="">
                Show Inactive Groups and Locations
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row group-nav-path">
        <div class="col-sm-12">
          <span></span>
        </div>
      </div>
      <div id="group-nav-options">
        <div class="row group-options">
        </div>
        <div class="row location-options">
        </div>
      </div>
    `;

    this.group_nav_path = this.querySelector(".group-nav-path span");
    this.group_nav_breadcrumb_pills = document.querySelector("#group_nav_breadcrumb_pills");
    this.group_options = this.querySelector(".group-options");
    this.location_options = this.querySelector(".location-options");

    this.querySelector("#show_inactive").checked = this.show_inactive = localStorage.getItem("show_inactive") == 'true'
    this.querySelector("#show_inactive").addEventListener("change", function(){
      this.show_inactive = this.querySelector("#show_inactive").checked;
      localStorage.setItem("show_inactive", this.show_inactive)
      this.querySelector("#group-filter").value.length > 0 ? this.handleSearch() : this.loadTree()
      if(this.currentPath.length > 0) {
        this.loadGroup(this.currentPath[this.currentPath.length-1].id, this.show_inactive)
      }
    }.bind(this));
    this.handleSearchListeners();
    if(this.currentPath.length > 0) {
      this.loadTree();
      this.renderBreadcrumb();
      this.loadGroup(this.currentPath[this.currentPath.length-1].id, this.show_inactive)
    } else {
      this.loadTree();
    }
  }

  get currentPath() {
    return localStorage.getItem("group_path") ? JSON.parse(localStorage.getItem("group_path")) : [];
  }

  set currentPath(path) {
    return localStorage.setItem("group_path", JSON.stringify(path));
  }

  handleSearchListeners() {
    let timeout = null;
    this.querySelector("#group-filter").addEventListener("keyup", function(e) {
      if(timeout) { clearTimeout(timeout); }
      timeout = setTimeout(function() {
        this.handleSearch();
      }.bind(this),750);
    }.bind(this))

    this.querySelector("#group-filter-options select").addEventListener("change", function(e) {
      if(Number(e.target.value) == GroupNav.SEARCH_TYPE.LOCATION_BY_DID) {
        $(this.querySelector("#group-filter")).mask('(999) 999-9999')
        this.querySelector("#group-filter").value = "";
      } else {
        $(this.querySelector("#group-filter")).unmask();
        this.handleSearch();
      }
    }.bind(this));
  }

  handleSearch() {
    this.currentPath = []
    let value = this.querySelector("#group-filter").value.trim();
    let search_type = parseInt(this.querySelector("#group-filter-options select").value);
    if(search_type == GroupNav.SEARCH_TYPE.LOCATION_BY_DID) {
      value = value.replace(/[^\d]/g, '');;
      if(value.length < 10) {
        return;
      }
    }
    if(value.length > 2) {
      this.loadTree(value, search_type) 
    } else if(value.length == 0) {
      this.loadTree(value, search_type) 
    }
  }

  async loadTree(search=null, search_type=null) {

    this.group_options.innerHTML = "Loading...";

    let show_inactive = this.show_inactive;
    let search_query = false;
    let query = "";
    if(search != null && search.length > 0){
      query = `?q=${encodeURIComponent(search)}&type=${search_type}${show_inactive ? "&show_inactive=1":""}`;
      search_query = true;
    } else if(show_inactive) {
      query = "?show_inactive=1"
    }

    let json = null;
    this.group_options.innerHTML = "Loading...";
    this.location_options.innerHTML = "";

    // Either resetting the tree or searching.
    
    if(this.currentPath.length == 0){
      this.renderBreadcrumb();
      let res = await fetch(`/admin/groups/permission/admin:view${query}`);
      json = await res.json();

      this.group_options.innerHTML = "";
      if(json.locations.length == 0 && json.groups.length == 0 && search != null) {
        this.group_options.innerHTML = `<span style='padding-left: 20px;'>No Groups or Locations found for ${search}.</span>`;
        return;
      }
    } else {
      let group_id = this.currentPath[this.currentPath.length-1].id;

      let res = await fetch(`/admin/groups/${group_id}/groups_locations/permission/admin:view${query}`);
      json = await res.json();
    }
    
    if(!search_query) {
      this.loadGroups(json.groups);
      this.loadLocations(json.locations);
    }
    else {
      this.loadSearchResults(json);
    }
  }

  async loadLocationsForSearch(search, search_type) {

    this.group_options.innerHTML = "Loading...";

    this.location_options.innerHTML = "";
    this.currentPath = [];
    this.renderBreadcrumb();

    let show_inactive = this.querySelector("#show_inactive").checked;

    let query = "";
    if(search != null && search.length > 0){
      query = `?q=${search}&type=${search_type}${show_inactive ? "show_inactive=1":""}`;
    } else if(show_inactive) {
      query = "?show_inactive=1"
    }

    this.location_options.innerHTML = "";
    this.renderBreadcrumb();
    let res = await fetch(`/admin/domains/permission/admin:view`+query);
    
    let json = await res.json();

    this.group_options.innerHTML = "";
    this.location_options.innerHTML = "";

    if(json.length == 0) {
      this.group_options.innerHTML = `<span style='padding-left: 20px;'>No Locations found for ${search}.</span>`;
    }

    json.forEach(function(location) {
      this.location_options.appendChild(new GroupNavLocationOption(location, this.locationDrillDown.bind(this)) );
    }.bind(this));
  }

  loadGroups(groups) {
    this.group_options.innerHTML = "";
    groups.forEach(function(group) {
      this.group_options.appendChild(new GroupNavGroupOption(group, this.groupDrillDown.bind(this)) );
    }.bind(this));
  }

  async loadLocations(locations) {
    this.location_options.innerHTML = "";
    locations.forEach(function(location) {
      this.location_options.appendChild(new GroupNavLocationOption(location, this.locationDrillDown.bind(this)) );
    }.bind(this));
  }

  loadSearchResults(results) {
    this.group_options.innerHTML = "";
    results.groups.forEach(
      (group) => {
        this.group_options.appendChild(new GroupNavGroupOption({id: group.auto_group_id, name: group.auto_group_name, inactive_date: group.inactive_date}, (group_drill_down) => {
          let group_ids = group.path.slice(1, -1).split("/");
          let group_names = group.path_name.slice(1, -1).split("/");
          group_ids.pop();
          group_names.pop();
          this.currentPath = group_ids.map((id, index) => {return {id: id, name: group_names[index]}})
          this.groupDrillDown(group_drill_down) ;
        })); 
      }
    );

    this.location_options.innerHTML = "";
    results.locations.forEach(
      (location) => {
        this.location_options.appendChild(new GroupNavLocationOption({domain_id: location.domain_id, location_name: location.location_name, inactive_date: location.inactive_date}, (location_drill_down) => {
          let group_ids = location.path.slice(1, -1).split("/")
          let group_names = location.path_name.slice(1, -1).split("/")
          this.currentPath = group_ids.map((id, index) => {return {id: id, name: group_names[index]}})
          this.locationDrillDown(location_drill_down);
        }));
    });
  }

  loadSplashScreen() {
    this.currentPath = [];
    document.querySelector("group-management .content").innerHTML = '<groups-splash-screen></groups-splash-screen>';
    this.loadTree();
  }

  renderBreadcrumb(location = null) {
    let home = document.createElement("span")
    home.innerHTML = "Home"
    home.addEventListener("click", function() {
      this.loadSplashScreen();
    }.bind(this));

    let home_pill = document.createElement("span")
    home_pill.innerHTML = "Home"
    home_pill.classList.add("badge", "badge-pill", "badge-dark")
    home_pill.style.marginRight = "10px"
    home_pill.style.cursor = "pointer"
    home_pill.addEventListener("click", function() {
      this.loadSplashScreen();
    }.bind(this));

    this.group_nav_path.innerHTML = "";
    this.group_nav_breadcrumb_pills.innerHTML = ""
    this.group_nav_path.appendChild(home);
    if(this.currentPath.length > 0) {
      this.group_nav_breadcrumb_pills.appendChild(home_pill);
    }

    this.currentPath.forEach(function(item) {
        this.group_nav_path.appendChild(document.createTextNode(" / "))
        this.group_nav_path.appendChild(new GroupNavBreadcrumb(item, this.groupDrillUp.bind(this)))
        this.group_nav_breadcrumb_pills.appendChild(new GroupNavBreadcrumb(item, this.groupDrillUp.bind(this), "badge badge-pill badge-dark"))
      }.bind(this));

    if(location != null) {
      let location_span = document.createElement("span")
      location_span.innerHTML = location.location_name;
      this.group_nav_path.appendChild(document.createTextNode(" / "));
      this.group_nav_path.appendChild(location_span);
    }
  }

  groupDrillDown(group) {
    this.querySelector("#group-filter").value = "";
    this.currentPath = this.currentPath.concat([group]);
    //this.currentPath = this.currentPath;
    this.renderBreadcrumb();
    let group_id = this.currentPath[this.currentPath.length-1].id;
    this.loadGroup(group_id, this.show_inactive)

    this.loadTree()
  }

  groupDrillUp(group) {
    this.currentPath = this.currentPath.slice(0, this.currentPath.map(function(e) { return e.id; }).indexOf(group.id)+1);
    this.renderBreadcrumb();
    let group_id = this.currentPath[this.currentPath.length-1].id;
    this.loadTree();
    this.loadGroup(group_id, this.show_inactive);
  }

  locationDrillDown(location) {
    this.renderBreadcrumb(location)
    window.location = `/admin/domains/${location.domain_id}/edit`;
  }

  loadGroup(group_id, show_inactive = false) {
    document.querySelector("group-management").showNav();
    let group_admin = new GroupAdmin(group_id, this.is_admin, this.groupChanged.bind(this), show_inactive)
    document.querySelector("group-management .content").innerHTML = '';
    document.querySelector("group-management .content").appendChild(group_admin)
  }

  groupChanged(updated_name = null) {
    if(updated_name != null) {
      this.currentPath[this.currentPath.length-1].name = updated_name;
    }
    this.renderBreadcrumb()
    this.loadTree()
  }
}

GroupNav.SEARCH_TYPE = {
  GROUPS_AND_LOCATIONS: 1,
  LOCATION_BY_DID: 2,
  GROUPS_BY_EMAIL: 3,
}

customElements.define('group-nav', GroupNav)

class GroupNavGroupOption extends HTMLElement {
  constructor(group, open_callback) {
    super();
    this.group = group
    this.open = open_callback
  }

  connectedCallback() {
    let is_inactive = this.group.inactive_date != null && moment.utc(this.group.inactive_date).isBefore(moment.utc())  

    this.innerHTML = `
      <style>
        group-nav-group-option {
          padding-left: 30px;
          width: 100%;
          display: block;
          cursor: pointer;
          font-size: 14px;
          margin: 10px 0px;
        }

        group-nav-group-option span {
          position:relative;
        }

        group-nav-group-option span:before{
          width: 16px;
          content: " ";
          background-image: url(/assets/admin/groups_arrow.svg);
          position: absolute;
          left: -20px;
          top: -4px;
          height:20px;
        }

        group-nav-group-option:hover span:before{
          background-image: url(/assets/admin/groups_arrow_hover.svg);
        }

        group-nav-group-option span.is_inactive {
          color: #a94442;
        }
      </style>
      <span class="${is_inactive ? "is_inactive" : ""}">${this.group.name}</span>
    `

    this.addEventListener("click", function() {
      this.open(this.group)
    }.bind(this));
  }
}

customElements.define('group-nav-group-option', GroupNavGroupOption)

class GroupNavLocationOption extends HTMLElement {
  constructor(location, open_callback) {
    super();
    this.location = location
    this.open = open_callback
  }

  connectedCallback() {
    let is_inactive = this.location.inactive_date != null && moment.utc(this.location.inactive_date).isBefore(moment.utc())  
    
    this.innerHTML = `
      <style>
        group-nav-location-option {
          padding-left: 30px;
          width: 100%;
          display: block;
          cursor: pointer;
          font-size: 14px;
          margin: 10px 0px;
        }

        group-nav-location-option span {
          position:relative;
        }

        group-nav-location-option span.is_inactive {
          color: #a94442;
        }
      </style>
      <span class="${is_inactive ? "is_inactive" : ""}">${this.location.location_name}</span>
    `

    this.addEventListener("click", function() {
      this.open(this.location)
    }.bind(this));
  }
}

customElements.define('group-nav-location-option', GroupNavLocationOption)

class GroupNavBreadcrumb extends HTMLElement {
  constructor(item, click_callback, classes="") {
    super()
    this.item = item;
    this.click_callback = click_callback;
    this.classes = classes
  }

  connectedCallback() {
    this.innerHTML = `<span class="${this.classes}">${this.item.name}</span>`

    this.addEventListener("click", function() {
      this.click_callback(this.item)
    }.bind(this))
  }
}

customElements.define('group-nav-breadcrumb', GroupNavBreadcrumb)

class GroupsSplashScreen extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = `
      <style>
        groups-splash-screen {
          padding-left: 25px;
          display: block;
        }

        ul {
          list-style: inside;
            margin: 12px;
            line-height:180%
        }

        h2 {
          margin-bottom: 20px;
        }
      </style>
      <div>
        <H2>Manage Accounts</H2>
        
        <p>
        <h3>Groups</h3>
        <p>Groups are a way to organize locations to make it easier for a user to control settings and pull reporting if they manage multiple locations.</p>
        <p>User permission can also be set at a group level if certain users only need access to a subset of locations in an account.</p>
        <ul>
          <li>Groups and Locations</li>
          <li>Users</li>
          <li>Branding</li>
          <li>Audio</li>
          <li>Integration Templates</li>
          <li>Tags</li>
          <li>Messaging </li>
          <li>Phone Management</li>
          <li>Billing</li>
        </ul>
        </p>
        <p style="margin-top: 20px;">
        <h3>Locations</h3>
        Create or Manage Locations.
        <ul>
          <li>Settings</li>
          <li>Digital Campaigns</li>
          <li>Campaigns</li>
          <li>Call Treatments</li>
          <li>Integration Management</li>
          <li>Advanced</li>
        </ul>
        </p>
        </div>`;
  }
}

customElements.define('groups-splash-screen', GroupsSplashScreen)